import { useEffect } from 'react';
import { VerticalReducedOptionsModal } from './VerticalReducedOptionsModal';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReducedOptionsModal = ({
  handleIframeSizeChange = () => {},
  hideBackground = false,
  onClose,
  upgradeData,
  onModalView,
  onClickChat,
  onClickCall,
  modalRoot
}) => {
  useEffect(() => {
    onModalView();
  }, [onModalView]);
  return /*#__PURE__*/_jsx(VerticalReducedOptionsModal, {
    handleIframeSizeChange: handleIframeSizeChange,
    hideBackground: hideBackground,
    onClose: onClose,
    upgradeData: upgradeData,
    onModalView: onModalView,
    onClickChat: onClickChat,
    onClickCall: onClickCall,
    modalRoot: modalRoot
  });
};